const CategoriesContainer = () => (
  <div className="categories-container">
    <p>This page is under construction!</p>
  </div>
);

export default CategoriesContainer;
